var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
var StyledImg = styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n"], ["\n  ",
    "\n  ", "\n  ", "\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n"])), function (_a) {
    var size = _a.size;
    return "\n    border-radius: " + size + ";\n    height: " + size + ";\n    min-height: " + size + ";\n    min-width: " + size + ";\n    width: " + size + ";\n  ";
}, function (_a) {
    var src = _a.src;
    return "background-image: url(" + src + ");";
}, function (_a) {
    var isSet = _a.isSet;
    return (isSet ? "opacity: 1;" : "opacity: 0.3;");
});
var Trophy = /** @class */ (function (_super) {
    __extends(Trophy, _super);
    function Trophy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Trophy.prototype.render = function () {
        var _a = this.props, isSet = _a.isSet, size = _a.size, src = _a.src;
        return React.createElement(StyledImg, { isSet: isSet, size: size, src: src });
    };
    Trophy.defaultProps = {
        isSet: true,
        size: "90px"
    };
    return Trophy;
}(PureComponent));
export default Trophy;
var templateObject_1;
